import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideTranslateService } from '@ngx-translate/core';
import { AppUserAuth, CoreModule, TransportConfig } from '@ubie/core';
import { SharedModule } from '@ubie/shared';
import { appRoutes } from './app.routes';

import { AdminCoreLibModule } from '@qbus/admin-core-lib';

import { environment } from '../environments/environment';

export function factoryGetConfig(): Promise<TransportConfig> {
  return new Promise((resolve) => {
    // get currently saved user to use the mqtt username and password
    const currentUser: AppUserAuth = JSON.parse(
      localStorage.getItem('currentUser') ?? 'null',
    );

    const mqtt = environment.mqtt;

    mqtt.user = currentUser.mqttUsername ?? '';
    mqtt.pass = currentUser.mqttPassword ?? '';

    return resolve(mqtt);
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(),
    provideAnimations(),
    provideTranslateService({
      useDefaultLang: true,
      defaultLanguage: 'public_1',
    }),
    provideIonicAngular({
      rippleEffect: true,
      useSetInputAPI: true,
    }),

    importProvidersFrom(
      CoreModule.forRoot({
        version: environment.version,
        apiRoot: environment.apiRoot,
        server: environment.server,
        logRoot: environment.logRoot,
        imageRoot: environment.imageRoot,
        appOrigin: 'admin',
        getTransportConfig: factoryGetConfig,
        calendar: environment.calendar,
        semsaWizardUrl: environment.semsaWizardUrl,
        lqsboxWizardUrl: environment.lqsBoxWizardUrl,
        admin: environment.admin,
        shouldCache: environment.shouldCache,
        publishers: environment.publishers,
        sonosClientId: environment.sonosClientId,
        isUbieTouch: environment.isUbieTouch,
        linkRoot: environment.linkRoot,
      }),
    ),

    importProvidersFrom(SharedModule),
    importProvidersFrom(AdminCoreLibModule),
  ],
};
